import React, { useLayoutEffect } from 'react';
import type { CSSProperties } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';

import { CREATING, DELAY, FINISHED, FROZEN, PAUSED, PLAYING } from 'state';
import { Button } from 'antd';

type props = {
  status: boolean;
  // delay: number;
};

const PassingTimeBanner: React.FC<props> = ({ status }) => {
  // useLayoutEffect(() => {
  //   if (status === true) {
  //     const scrollTop =
  //       window.pageYOffset || document.documentElement.scrollTop;
  //     const scrollLeft =
  //       window.pageXOffset || document.documentElement.scrollLeft;
  //
  //     function disableScroll() {
  //       window.scrollTo(scrollLeft, scrollTop);
  //     }
  //
  //     window.addEventListener('scroll', disableScroll);
  //
  //     return () => window.removeEventListener('scroll', disableScroll);
  //   }
  // }, [status]);

  // if (status === PLAYING || status === FINISHED || status === DELAY)
  // if (status === PLAYING || status === FINISHED) return null;

  const commonStyles = {
    position: 'fixed',
    zIndex: 99999,
  } as CSSProperties;

  const pausedStyles = {
    top: '50vh',
    right: 0,
    transformOrigin: 'right top',
    transform: 'rotate(90deg) translateX(50%)',
    backgroundColor: '#fadb14',
    padding: '5px 10px',
    fontSize: '18px',
  } as CSSProperties;

  const creatingStyles = {
    top: 0,
    left: 0,
    width: '100%',
    // marginTop: '2vh',
    // height: '98vh',
    height: '100vh',
    backgroundColor: 'rgba(255,255,255,0.16)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    // backdropFilter: 'blur(2px)',
    // WebkitBackdropFilter: 'blur(2px)',
    // blur: '22px',
  } as CSSProperties;

  const overlayStyles = {
    ...commonStyles,
    ...(status === true ? creatingStyles : commonStyles),
  };
  // const delayMultipleMinutes = status === DELAY && delay > 1;
  // const delayOneMinute = status === DELAY && delay === 1;

  return (
    <div style={overlayStyles}>
      <span
        style={{
          color: '#1f1f1f',
        }}
      >
        {status === true && (
          <div
            style={{
              backgroundColor: 'rgba(216,216,216,0.16)',
              backdropFilter: 'blur(2px)',
              WebkitBackdropFilter: 'blur(2px)',
              borderRadius: '15px',
              padding: '60px',
            }}
          >
            <InfoCircleOutlined style={{ marginRight: '5px' }} />
            Advancing to next period
            <Button
              ghost
              type={'default'}
              onClick={() => (window.location.href = '/dashboard')}
              style={{
                display: 'block',
                marginTop: '30px',
              }}
            >
              Exit session
            </Button>
          </div>
        )}
      </span>
    </div>
  );
};

export default PassingTimeBanner;
